'use client';

import { useState, useEffect } from 'react';
import { Mail, X } from 'lucide-react';

export default function EmailButton() {
  const [isVisible, setIsVisible] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);

  // Show button after scrolling
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Show tooltip after a delay
  useEffect(() => {
    if (isVisible) {
      // Check if tooltip has been shown before
      const hasShownTooltip = localStorage.getItem('email_tooltip_shown');

      if (!hasShownTooltip) {
        const timer = setTimeout(() => {
          setShowTooltip(true);
          // Auto-hide after 10 seconds
          setTimeout(() => {
            setShowTooltip(false);
          }, 10000);
        }, 3000);

        return () => clearTimeout(timer);
      }
    }
  }, [isVisible]);

  const handleEmailClick = () => {
    const subject = "Consulta sobre servicios de IA";
    const body = "Hola, estoy interesado en sus servicios de inteligencia artificial. Me gustaría obtener más información.";
    const mailtoLink = `mailto:info@pime.ai?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    
    window.open(mailtoLink, '_blank');

    // Mark tooltip as shown
    localStorage.setItem('email_tooltip_shown', 'true');
    setShowTooltip(false);
  };

  const dismissTooltip = () => {
    setShowTooltip(false);
    localStorage.setItem('email_tooltip_shown', 'true');
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-6 right-6 sm:right-10 z-50">
      {/* Tooltip */}
      {showTooltip && (
        <div className="absolute bottom-16 right-0 bg-white rounded-lg shadow-lg p-4 w-64 text-sm animate-fade-in mb-2">
          <button
            onClick={dismissTooltip}
            className="absolute top-2 right-2 text-gray-400 hover:text-gray-600"
            aria-label="Cerrar"
          >
            <X size={16} />
          </button>
          <p className="font-medium text-gray-800 mb-1">¿Tienes preguntas?</p>
          <p className="text-gray-600 mb-3">Contáctanos directamente por email y responderemos lo antes posible.</p>
          <button
            onClick={handleEmailClick}
            className="w-full bg-blue-500 hover:bg-blue-600 text-white text-sm py-2 px-4 rounded flex items-center justify-center"
          >
            <Mail className="w-4 h-4 mr-2" />
            Contactar ahora
          </button>
        </div>
      )}

      {/* Main button */}
      <button
        onClick={handleEmailClick}
        className="bg-blue-500 hover:bg-blue-600 text-white rounded-full p-3.5 shadow-lg transition-all duration-300 hover:scale-110 hover:shadow-xl focus:outline-none relative"
        aria-label="Contactar por email"
      >
        <Mail className="w-6 h-6" />

        {/* Pulsating effect */}
        <span className="absolute top-0 right-0 -mt-1 -mr-1 w-3 h-3 bg-red-500 rounded-full animate-ping"></span>
        <span className="absolute top-0 right-0 -mt-1 -mr-1 w-3 h-3 bg-red-500 rounded-full"></span>
      </button>

      {/* Label */}
      <div className="absolute -top-8 left-1/2 transform -translate-x-1/2 bg-black bg-opacity-75 text-white text-xs px-2 py-1 rounded whitespace-nowrap hidden sm:block">
        Contacto rápido
      </div>
    </div>
  );
}
